module.exports = __webpack_public_path__ + "img/immagini_sfondo_home.4ec2bae1.png";